<script lang="ts">
    import { Image} from "sveltestrap";
    import { Send } from "../../../../utils/Constant/Constant";
    import {selectList} from "../../../../store"
    import 'emoji-picker-element';
    let imgPath:string = "/assets/images/user"
    export let setMessage:string
    let time:any
    let setSelectList:any
    selectList.subscribe((value)=>{
      setSelectList = value
    })
</script>
<div class="chat-history chat-msg-box custom-scrollbar">
    <ul>
      {#each setSelectList as chatItem}
        <li>
          <div class="message my-message">
            <Image class="rounded-circle float-start chat-user-img img-30" src="{imgPath}/{chatItem.img}" alt="" />
            <div class="message-data text-end">
              <span class="message-data-time">{'10:12 am'}</span>
            </div>{Send}
          </div>
        </li>
      {/each}
      {#if setMessage !== undefined}
        <li class="clearfix">
          <div class="message other-message pull-right">
            <Image class="rounded-circle float-end chat-user-img img-30" src="{imgPath}/12.png" alt="" />
            <div class="message-data">
              <span class="message-data-time">{time}</span>
            </div>{setMessage}
          </div>
        </li>
      {/if}
    </ul>
</div>
